import React from "react";

const LoadingState = ({ message = "Loading..." }) => (
  <div className="billr-loading">
    <div className="billr-spinner" />
    <span>{message}</span>
  </div>
);

export default LoadingState;
